export const Messages = {
  NO_APPROVALS: 'No Pending Approvals',
  NO_REQUESTS: 'No Pending Requests',
  NO_CLONE_REQUESTS: 'No Clone Travel Requests Found',
  NO_ATTACHMENTS: 'No Attachments Found',
  NO_APPROVERS: 'No Approvers Found',
  NO_PO_FOUND: 'No Purchase Orders Found',
  NO_REVISIONS: 'No Revisions Found',

  NO_EMP_PERFORMANCE: 'No Employee Performance Data Found',
  NO_REASSIGN: 'No Reassign Approvals Found',

  NO_USERS: 'No Users Found',
  NO_CALIBRATION: 'No Calibration Sessions Found',
  NO_EMPLOYEE_FOUND: 'No Employees Found',

  NO_COMP_OFF: 'No Comp Off Data Found',
  NO_OVERTIME: 'No Overtime Data Found',
  NO_EXPENSES: 'No Expense Claims Found',
  NO_LEAVE: 'No Leave Data Found',
  NO_LOAN: 'No Loan Data Found',
  NO_TRAVEL: 'No Travel Data Found',
  NO_WFH: 'No WFH Data Found',
  NO_TIMESHEET: 'No Timesheet Data Found',

  DEFAULT_NO_DATA: 'No Data Found',
};
